/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AcceptConsultParams {
  channelId?: string;
  /** @format int32 */
  consultId: number;
  messageId?: string;
}

export interface AiGuideBotModelsSendInitialMessageRequest {
  conversationId: string;
  message: string;
}

export interface AiGuideBotModelsSubmitFeedbackRequest {
  conversationId: string;
  isPositive: boolean;
  negativeReasons?: string[] | null;
}

export interface AiGuideBotResponsesChatConfigDto {
  conversationId: string;
  token: string;
  userId?: string | null;
}

export interface BookNonConfirmedConsultParams {
  email?: string;
}

export interface BookNonConfirmedConsultWithPsychologistParams {
  email?: string;
  psychologistId: string;
}

export interface ConfirmConsultParams {
  token?: string;
}

export interface ConfirmSpaceUserParams {
  token?: string;
}

export interface ConfirmUserParams {
  /** User verification code */
  token?: string;
}

export interface ConnectTranscriptionParams {
  /** @format int32 */
  consultId: number;
  serverCallId?: string;
}

export interface CreateChannelJsonPayload {
  /** The channel URL */
  channel_url?: string;
  /** The clients to be invited to the channel after its creation */
  client_ids?: string[];
  /**
   * The image file to associate with the channel
   * @format binary
   */
  cover_file?: File;
  /** The URL of the image to associate with the channel */
  cover_url?: string;
  /** A description of the channel */
  description?: string;
  /** If you are creating a 1-on-1 direct messaging channel for a user, it is recommended that you turn on the distinct property. If the property is turned off, a user can create a new channel even if they have had the previous chat between them, and therefore can't see previously sent messages or data in the new channel. On the other hand, if the distinct property is turned on, every 1-on-1 conversation between the same two users occurs within the same channel. */
  is_distinct?: boolean;
  /** Determines whether to preserve the messages in the channel for the purpose of retrieving chat history. (Default: false) */
  is_ephemeral?: boolean;
  /** Determines whether to allow a user to join the channel without an invitation. (Default: false) */
  is_public?: boolean;
  /**
   *  Determines whether to allow the channel to accommodate more than 2,000 members. (Default: false)
   * * Supergroup channels are not supported with the is_distinct property and the property is false by default.
   */
  is_super?: boolean;
  /** The channel language */
  language?: string;
  /** The name of the channel */
  name?: string;
}

export type CreateEmployer2Payload = any;

export interface CreateGuestUserParams {
  /** User's unconfirmed data token */
  token?: string;
}

export interface DeclineConsultParams {
  channelId?: string;
  /** @format int32 */
  consultId: number;
  messageId?: string;
}

export type DeleteSessionNotePayload = string[];

export interface DossierNote {
  value?: string | null;
}

export interface GenerateInvitationLinkParams {
  channelId?: string;
  isEnabled?: boolean;
}

export interface GeneratePdfParams {
  url?: string;
}

export interface GenerateXlsxParams {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetAccountsCountReportDataParams {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetAccountsCountReportDataParams2 {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetAcsTokenParams {
  roomId?: string;
}

export interface GetAllSessionsParams {
  /** @format uuid */
  employerId?: string;
  expertId?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  searchTerm?: string;
  /** @format date-time */
  startedAtFrom?: string;
  /** @format date-time */
  startedAtTo?: string;
  status?: string;
}

export interface GetAutocompleteParams {
  languageCode?: string;
  /** @format int32 */
  limit?: number;
  q?: string;
}

export interface GetClientConsultParams {
  /**
   * The consultId
   * @format int32
   */
  consultId: number;
  /** Specific status to exclude in the consult filtering */
  statusToExclude?: string;
  /** Specific status to filter the consult by */
  statusToFilterBy?: string;
}

export interface GetClientConsultsAndSpacesParams {
  /** @default true */
  clientView?: boolean;
  /** @default false */
  includeExpertDetails?: boolean;
  /** @default "en-US" */
  languageCode?: string;
  /** @format int32 */
  limit?: number;
  notesFormat?: string;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetClientConsultsParams {
  clientView?: boolean;
  includeNotes?: boolean;
  notesFormat?: string;
}

export interface GetClientSpacesParams {
  /** userId of client */
  clientId: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetClientsParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetConsultsFeedbacksParams {
  /** @format date-time */
  fromDate?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetContentsParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetEmployers2Params {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetEmployersParams {
  /** When true or null, returns only active employers. When false, returns all employers including inactive ones. */
  activeOnly?: boolean;
  /** Optional filter to search employers by company name */
  companyName?: string;
}

export interface GetEngagedUsersReportDataParams {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetEngagedUsersReportDataParams2 {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetExpertFeedbacksParams {
  dateFilter?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetExpertParams {
  personalUrlHandle: string;
  /** @default "en-GB" */
  profileLanguage?: string;
}

export interface GetExpertTagsParams {
  /** The ID of the client */
  clientId?: string;
  /** The ID of the expert */
  expertId: string;
}

export interface GetExpertsParams {
  active?: boolean;
  expertProfileLanguage?: string;
  languages?: string[];
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  themes?: string[];
  topics?: string[];
  userNumber?: string;
}

export interface GetLatestSpacesParams {
  /**
   * @format int32
   * @default 8
   */
  count?: number;
  language?: string;
  theme?: string;
}

export interface GetLoggedInExpertTagsParams {
  /** The ID of the client */
  clientId?: string;
}

export interface GetManagerMixedContentsParams {
  excludeContentTypes?: string[];
  languageCode?: string;
  topics?: string[];
  /** @format int32 */
  totalCount?: number;
}

export interface GetMixedContentsParams {
  languageCode?: string;
  /** @format int32 */
  totalCount?: number;
}

export interface GetModulesParams {
  languageCode?: string;
}

export interface GetNonConfirmedConsultParams {
  token?: string;
}

export interface GetPagedMixedContentsParams {
  audience?: string;
  language?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  themes?: string[];
  type?: string[];
}

export interface GetPsychologistClientsParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetPsychologistConsultsParams {
  /** @format uuid */
  employerId?: string;
  expertId?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  searchTerm?: string;
  /** @format date-time */
  startedAtFrom?: string;
  /** @format date-time */
  startedAtTo?: string;
  status?: string;
}

export interface GetPsychologistsParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetQuestionListDefinitionParams {
  /** The name of the question list */
  formName?: string;
  /** The language of the question list */
  language?: string;
}

export interface GetReferralToolkitFileParams {
  employerId: string;
  fileName?: string;
}

export interface GetSessionNotesParams {
  /** @format date-time */
  fromDate?: string;
  /** @format date-time */
  toDate?: string;
}

export interface GetSessionReferralsParams {
  /** @format date-time */
  fromDate?: string;
  /** @format date-time */
  toDate?: string;
}

export interface GetSessionsThemesDataParams {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetSessionsThemesDataParams2 {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetSessionsThemesForTopicsReportParams {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetSessionsThemesForTopicsReportParams2 {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetSessionsTopicsData2Params {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetSessionsTopicsDataParams {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
}

export interface GetSessionsTopicsDataParams2 {
  /** @format date */
  date?: string;
  /** @format uuid */
  employerId: string;
  themeKey: string;
}

export interface GetSpaceEventsParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface GetTagsAvailableForClientParams {
  availableForUserId?: string;
  tagType: string;
}

export interface GetThemesParams {
  "session_types[]"?: string[];
}

export interface GetTimeSlotsInFirstAvailableWeek3Params {
  /** @format date-time */
  endDate?: string;
  /** @format date-time */
  startDate?: string;
  timeZone?: string;
}

export interface GetTimeSlotsInFirstAvailableWeekParams {
  /** @format date-time */
  endDate?: string;
  psychologistId: string;
  /** @format date-time */
  startDate?: string;
  timeZone?: string;
}

export interface GetTripettoFormDefinitionByThemeParams {
  language?: string;
  themeKeys?: string[];
}

export interface GetTripettoFormDefinitionParams {
  /** The name of the question list */
  formName?: string;
  /** The language of the question list */
  language?: string;
}

export interface GetUserQuestionListScoresParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  questionListKey?: string;
  search?: string;
}

export interface GetVitalityCheckinParams {
  /** The language code (e.g., "en-GB") */
  language?: string;
  /** The type of check-in (e.g., "stress-and-coping") */
  name?: string;
}

export interface GetVitalityCheckinRecommendationsParams {
  /** @default "en" */
  languageCode?: string;
}

export interface GetWhoElseInCallParams {
  roomId?: string;
}

export interface IsExpertInCallParams {
  roomId?: string;
}

export interface LastCompletedConsultsByTypeParams {
  /** @default false */
  includeExpertDetails?: boolean;
  /** @default "en-US" */
  languageCode?: string;
}

export interface LoginGuestParams {
  token?: string;
}

export interface MicrosoftAspNetCoreMvcProblemDetails {
  detail?: string | null;
  instance?: string | null;
  /** @format int32 */
  status?: number | null;
  title?: string | null;
  type?: string | null;
  [key: string]: any;
}

export interface ModelsAnswer {
  /** @format date-time */
  dateValue?: string | null;
  /** @format int32 */
  intValue?: number | null;
  name?: string | null;
  textValue?: string | null;
}

export interface ModelsCalendar {
  accessToken?: string | null;
  /** @format date-time */
  accessTokenExpiration?: string | null;
  calendarId?: string | null;
  description?: string | null;
  /** @format date-time */
  lastUpdatedAt?: string | null;
  refreshToken?: string | null;
  summary?: string | null;
  timeZone?: string | null;
  userId?: string | null;
  /** @format date-time */
  watchResourceExpiration?: string | null;
  watchResourceId?: string | null;
}

export interface ModelsChatChannelInvitationToken {
  channelId?: string | null;
  invitationLink?: string | null;
  isEnabled: boolean;
}

export interface ModelsCompanyReportThemesReport {
  employerId?: string | null;
  key?: string | null;
  /** @format double */
  lastThreeMonthsCurrentPeriod: number;
  /** @format double */
  previousThreeMonths: number;
}

export enum ModelsConsultMeetingProvider {
  None = "None",
  Sessions24 = "Sessions24",
  Acs = "Acs",
}

export interface ModelsConsultReview {
  /** @format int32 */
  answer1: number;
  /** @format int32 */
  answer2: number;
  /** @format int32 */
  answer3: number;
  feedback?: string | null;
}

/** @format int32 */
export enum ModelsConsultStatus {
  Scheduled = "Scheduled",
  CancelledByClient = "CancelledByClient",
  CancelledByOpenUp = "CancelledByOpenUp",
  Completed = "Completed",
  MissedByClient = "MissedByClient",
  MissedByOpenUp = "MissedByOpenUp",
  MissedByBoth = "MissedByBoth",
}

export interface ModelsDtosTimezoneDto {
  name?: string | null;
  /** @format 0.00:00:00 */
  utcOffset: string;
  /** @format double */
  utcOffsetInMinutes: number;
  zoneId?: string | null;
}

export interface ModelsEmployer {
  active: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  name?: string | null;
  planhatId?: string | null;
  slug?: string | null;
}

/** @format int32 */
export enum ModelsEnumCategory {
  None = "None",
  Low = "Low",
  Medium = "Medium",
  High = "High",
}

export interface ModelsExternalQuestionnaire {
  clientId?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  externalId: string;
  /** @format uuid */
  id: string;
  resultLink?: string | null;
  shareLink?: string | null;
  type?: string | null;
}

export interface ModelsFormDefinition {
  definition?: string | null;
  locale?: string | null;
  modules?: string[] | null;
  styles?: string | null;
  translations?: string | null;
}

export interface ModelsNotes {
  answer?: string | null;
  /** @format int32 */
  consultId: number;
  question?: string | null;
}

/** @format int32 */
export enum ModelsOpenUpRole {
  Automation = "Automation",
  Guest = "Guest",
  Client = "Client",
  Expert = "Expert",
  Admin = "Admin",
  Manager = "Manager",
  Consult = "Consult",
  Checkin = "Checkin",
  Host = "Host",
  CustomerSuccess = "CustomerSuccess",
  HumanResource = "HumanResource",
  Support = "Support",
}

export interface ModelsQuestion {
  answers?: ModelsAnswer[] | null;
  goal?: string | null;
  isNegated: boolean;
  isScored: boolean;
  key?: string | null;
  /** @format int32 */
  ordinal: number;
  questionType: ModelsQuestionType;
  /** @format int32 */
  rank?: number | null;
  /** @format int32 */
  scale?: number | null;
  /** @format double */
  score: number;
  text?: string | null;
  tip?: string | null;
  /** @format double */
  weight: number;
}

export interface ModelsQuestionListAnswer {
  answers?: string[] | null;
  questionKey?: string | null;
  questionText?: string | null;
  questionType?: string | null;
}

export interface ModelsQuestionListAnswers {
  answers?: ModelsQuestionListAnswer[] | null;
  languageCode?: string | null;
  questionListKey?: string | null;
}

/** @format int32 */
export enum ModelsQuestionType {
  MultipleChoice = "MultipleChoice",
  CheckBox = "CheckBox",
  CheckBoxes = "CheckBoxes",
  Date = "Date",
  Dropdown = "Dropdown",
  Email = "Email",
  FileUpload = "FileUpload",
  Matrix = "Matrix",
  Number = "Number",
  Paragraph = "Paragraph",
  Password = "Password",
  PhoneNumber = "PhoneNumber",
  PictureChoice = "PictureChoice",
  RadioButtons = "RadioButtons",
  Rating = "Rating",
  Scale = "Scale",
  Statement = "Statement",
  TextArea = "TextArea",
  Url = "Url",
  YesNo = "YesNo",
  Text = "Text",
  HiddenField = "HiddenField",
  CalculatorBlock = "CalculatorBlock",
}

export interface ModelsQuestionsQuestionList {
  category: ModelsEnumCategory;
  categoryTitle?: string | null;
  /** @format date-time */
  createdAt: string;
  key?: string | null;
  questions?: ModelsQuestion[] | null;
  /** @format double */
  score: number;
  scoreDescription?: string | null;
  scoreIconInUnicode?: string | null;
  scoreTitle?: string | null;
  themeKey?: string | null;
  /** @format uuid */
  userId: string;
}

/** @format int32 */
export enum ModelsRequestSource {
  IsClientApp = "IsClientApp",
  IsDashboard = "IsDashboard",
  IsMobileiOS = "IsMobileiOS",
  IsMobileAndroid = "IsMobileAndroid",
  IsCustomerSuccess = "IsCustomerSuccess",
}

export interface ModelsSendBirdModelsSendBirdChannelResponse {
  access_code?: string | null;
  channel_url?: string | null;
  cover_url?: string | null;
  custom_type?: string | null;
  data?: string | null;
  inviter_id?: string | null;
  is_distinct: boolean;
  is_ephemeral: boolean;
  is_public: boolean;
  is_super: boolean;
  members?: ServicesSendBirdModelsSendBirdUser[] | null;
  name?: string | null;
  operator_ids?: string[] | null;
  operators?: ServicesSendBirdModelsSendBirdUser[] | null;
  user_ids?: string[] | null;
}

export interface ModelsTag {
  description?: string | null;
  name?: string | null;
  tagType: ModelsTagType;
}

export interface ModelsTagType {
  isExclusive: boolean;
  name?: string | null;
  tags?: ModelsTag[] | null;
}

export interface ModelsTheme {
  /** @format date-time */
  createdAt: string;
  isFocused: boolean;
  isTrackedTheme: boolean;
  key?: string | null;
  /** @format date-time */
  lastModifiedAt: string;
  /** @format int32 */
  ordinal?: number | null;
  questionLists?: ModelsQuestionsQuestionList[] | null;
  tags?: ModelsTag[] | null;
  /** @format uuid */
  themeDefinitionId: string;
  userId?: string | null;
}

export interface ModelsTimeSlot {
  /** @format date-time */
  endTime: string;
  /** @format date-time */
  startTime: string;
}

export enum ModelsTwoFactorAuthMethod {
  Phone = "Phone",
  AuthenticatorKey = "AuthenticatorKey",
}

export interface ModelsUser {
  /** @format date-time */
  acceptedMedicalDataProcessing?: string | null;
  /** @format date-time */
  acceptedTermsAndConditions: string;
  calendar: ModelsCalendar;
  /** @format date-time */
  createdAt: string;
  createdBy?: string | null;
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  /** @format uuid */
  employerId?: string | null;
  employerName?: string | null;
  /**
   * @minLength 1
   * @maxLength 25
   */
  firstName: string;
  hasDeskJob?: boolean | null;
  id?: string | null;
  isEmailConfirmed: boolean;
  isFocusThemeSet?: boolean | null;
  isManager?: boolean | null;
  isPartner: boolean;
  readonly isRegistered: boolean;
  isSignedUpToNewsLetter: boolean;
  isTouchedByPsychologist: boolean;
  isTranscriptionAllowed: boolean;
  languageCode?: string | null;
  /** @format date-time */
  lastLoginAt?: string | null;
  /**
   * @minLength 1
   * @maxLength 25
   */
  lastName?: string | null;
  lockoutEnabled: boolean;
  /** @format date-time */
  lockoutEnd?: string | null;
  loginProvider?: string | null;
  passwordHash?: string | null;
  personalUrlHandle?: string | null;
  /** @format tel */
  phoneNumber?: string | null;
  phoneNumberConfirmed: boolean;
  preferences?: ModelsUserPreference[] | null;
  roles?: ModelsOpenUpRole[] | null;
  signUpToNewsletter: boolean;
  tags?: ModelsTag[] | null;
  /** @format int32 */
  twoFactorCodeRequestCount: number;
  /** @format date-time */
  twoFactorCodeRequestedAt?: string | null;
  twoFactorEnabled: boolean;
  /** @format int32 */
  userNumber: number;
  worksTwentyFourSeven: boolean;
  /** @format int32 */
  yearOfBirth?: number | null;
}

export interface ModelsUserPreference {
  category?: string | null;
  name?: string | null;
  value: boolean;
}

export type NewtonsoftJsonLinqJToken = NewtonsoftJsonLinqJToken[];

export interface OpenUpBIApiResponsesConsultFeedbackWithEmployerResponse {
  clientId: string;
  /** @format date */
  consultMonth: string;
  /** @format uuid */
  employerId: string;
  employerName: string;
  feedback: string;
}

export interface OpenUpBIApiResponsesConsultFeedbackWithEmployerResponsePaginated {
  data: OpenUpBIApiResponsesConsultFeedbackWithEmployerResponse[];
  pagination: ResponsePagination;
}

export interface OpenUpBIApiResponsesSessionNotesResponse {
  /** @format int32 */
  consultId: number;
  /** @format int32 */
  notesWordCount: number;
}

export interface OpenUpBIApiResponsesSessionReferralsResponse {
  /** @format int32 */
  consultId: number;
  /** @format uuid */
  employerId?: string | null;
  expertId: string;
  nextSteps: string;
  provider: string;
  referrals: string;
  sessionLanguage: string;
  /** @format date-time */
  sessionStartDate: string;
  sessionType: string;
  userId: string;
}

export interface OpenUpEmployeesParams {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
}

export interface ProviderChallengePayload {
  /** E.g. Google */
  provider?: string;
  /** The OpenUp URL responsible for handling the login response */
  redirectUrl?: string;
}

export interface RegisterGuestUserAfterCheckInParams {
  /** Is this a medical checkin */
  isMedicalCheckin?: boolean;
}

export interface RegisterUserAndConfirmConsultParams {
  token?: string;
}

export interface RequestAvailableTimeSlotsRequest {
  /** @format date-time */
  endDate?: string | null;
  excludedExpertIds?: string[] | null;
  /** @format date-time */
  startDate: string;
  tags?: RequestTag[] | null;
  timeZone: string | null;
}

export interface RequestBookSlotRequest {
  previousExpertId?: string | null;
  recaptchaToken?: string | null;
  sessionContext?: string | null;
  tags: RequestTag[];
  /** @format date-time */
  time: string;
  timezone: string;
}

export interface RequestCancelConsultRequest {
  reason?: string | null;
}

export interface RequestChangePasswordRequest {
  newPassword?: string | null;
  oldPassword?: string | null;
}

export interface RequestClientCreateRequest {
  email?: string | null;
  /** @format uuid */
  employerId?: string | null;
  firstName?: string | null;
  gender?: string | null;
  isPartner: boolean;
  languageCode?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  /** @format int32 */
  yearOfBirth?: number | null;
}

export interface RequestClientUpdateRequest {
  /** @format uuid */
  employerId?: string | null;
  firstName?: string | null;
  gender?: string | null;
  isPartner: boolean;
  languageCode?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  /** @format int32 */
  yearOfBirth?: number | null;
}

export interface RequestCodeFlowRequest {
  code?: string | null;
  domain?: string | null;
}

export interface RequestConfirmConsultRequest {
  recaptchaToken?: string | null;
}

export interface RequestConsultCreateRequest {
  /** @minLength 1 */
  clientTimezone: string;
  consultLanguage?: string | null;
  consultType?: string | null;
  /** @minLength 1 */
  employeeId: string;
  /** @format string */
  notes?: string | null;
  /** @format date-time */
  startedAt: string;
  status: ModelsConsultStatus;
  themeKey?: string | null;
  /** @minLength 1 */
  userId: string;
}

export interface RequestConsultUpdateRequest {
  consultLanguage?: string | null;
  consultType?: string | null;
  /** @minLength 1 */
  employeeId: string;
  notes?: string | null;
  /** @format date-time */
  startedAt: string;
  status: ModelsConsultStatus;
}

export interface RequestContentContentEventRequest {
  /** @format int64 */
  contentId: number;
  entityId?: string | null;
  entityType?: string | null;
  eventType?: string | null;
  isRecommended?: boolean | null;
  metadata: RequestContentMetaDataRequest;
  platform?: string | null;
}

export interface RequestContentContentRequest {
  audience?: string | null;
  language?: string | null;
  themes?: string[] | null;
  type?: string[] | null;
}

export interface RequestContentDataRequest {
  key?: string | null;
  value?: string | null;
}

export interface RequestContentMetaDataRequest {
  data?: RequestContentDataRequest[] | null;
  section?: string | null;
  userAgent?: string | null;
  view?: string | null;
}

export interface RequestContentUpdateContentEngagementRequest {
  status?: string | null;
}

export interface RequestContentWordpressContentNotificationRequest {
  /** @format int64 */
  id: number;
  /** @format int64 */
  lessonId?: number | null;
  status?: string | null;
  type?: string | null;
}

export interface RequestCreateHumanResourcesUserRequest {
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  preferredLanguage?: string | null;
}

export interface RequestEmployerSsoRequest {
  email?: string | null;
}

export interface RequestEmployersAddEmployerRequest {
  name?: string | null;
  planhatId?: string | null;
}

export interface RequestEventEventRequest {
  entityId: string;
  entityType: string;
  eventType: string;
  isRecommended: boolean;
  metadata: RequestContentMetaDataRequest;
  platform: string;
}

export interface RequestExchangeCodeForTokenRequest {
  code?: string | null;
  domain?: string | null;
  provider?: string | null;
  requestSource: ModelsRequestSource;
}

export interface RequestExpertsEditExpertDetailsRequest {
  isTranscriptionAllowed?: boolean | null;
  worksTwentyFourSeven: boolean;
}

export interface RequestFilterPsychologistsRequest {
  tags?: RequestTag[] | null;
  themes?: RequestTheme[] | null;
}

export interface RequestFormAnswersRequest {
  answers?: Record<string, NewtonsoftJsonLinqJToken>;
  formLanguage?: string | null;
  formModules?: string[] | null;
}

export interface RequestIdTokenRequest {
  idToken?: string | null;
  provider?: string | null;
}

/** Request object to authenticate user using login API */
export interface RequestLoginRequest {
  /**
   * @format password
   * @minLength 0
   * @maxLength 255
   */
  password: string;
  recaptchaToken?: string | null;
  /**
   * @format email
   * @minLength 1
   */
  userName: string;
}

export interface RequestOtpRequest {
  email?: string | null;
  returnUrl?: string | null;
}

export interface RequestRefreshTokenRequest {
  token?: string | null;
}

export interface RequestRegisterCalendarRequest {
  calendarId?: string | null;
}

export interface RequestRegisterGuestUserRequest {
  acceptedMedicalDataProcessing: boolean;
  acceptedTermsAndConditions: boolean;
  email?: string | null;
  /** @format uuid */
  employerId?: string | null;
  firstName?: string | null;
  hasDeskJob?: boolean | null;
  isManager?: boolean | null;
  isPartner: boolean;
  lastName?: string | null;
  phoneNumber?: string | null;
  recaptchaToken?: string | null;
  /** @format int32 */
  yearOfBirth?: number | null;
}

export interface RequestRegisterUserRequest {
  acceptedMedicalDataProcessing: boolean;
  acceptedTermsAndConditions: boolean;
  email?: string | null;
  /** @format uuid */
  employerId?: string | null;
  firstName?: string | null;
  focusThemes?: string[] | null;
  hasDeskJob?: boolean | null;
  isManager?: boolean | null;
  isPartner: boolean;
  languageCode?: string | null;
  lastName?: string | null;
  password?: string | null;
  recaptchaToken?: string | null;
  redirectUri?: string | null;
  /** @format int32 */
  yearOfBirth?: number | null;
}

export interface RequestRescheduleConsultRequest {
  /** @format date-time */
  endStart: string;
  /** @format date-time */
  newStart: string;
  reason?: string | null;
  timezone?: string | null;
}

export interface RequestReschedulerSlotByTagsRequest {
  /** @format int32 */
  consultId: number;
  tags?: RequestTag[] | null;
  /** @format date-time */
  time: string;
  timezone?: string | null;
}

export interface RequestReschedulerSlotWithPsychologistRequest {
  /** @format int32 */
  consultId: number;
  /** @format date-time */
  time: string;
  timezone?: string | null;
}

export interface RequestResetPasswordRequest {
  code?: string | null;
  password?: string | null;
  recaptchaToken?: string | null;
  /** Email */
  userId?: string | null;
}

export interface RequestSendAdminMessageRequest {
  channelUrl?: string | null;
  customType?: string | null;
  hideFromOverview: boolean;
  isSilent: boolean;
  message?: string | null;
  sendPush: boolean;
}

export interface RequestSendBookingLoginEmailRequest {
  email?: string | null;
  psyUrlHandle?: string | null;
  recaptchaToken?: string | null;
}

export interface RequestSendPasswordResetEmailRequest {
  email?: string | null;
  recaptchaToken?: string | null;
  redirectUrl?: string | null;
}

export interface RequestSpacesConfirmSpaceUserRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
}

export interface RequestSpacesCreateSpaceUserRequest {
  email?: string | null;
  externalSpaceId?: string | null;
  sessionMetadata: RequestSpacesSessionMetadata;
}

export interface RequestSpacesSessionMetadata {
  /** @format uuid */
  eventId: string;
  eventTitle?: string | null;
  eventTypes: RequestSpacesSpaceSessionEventRequest;
  experts?: RequestSpacesSpaceSessionExpertRequest[] | null;
  languageCode?: string | null;
  /** @format int64 */
  spaceDateTime: number;
  /** @format uuid */
  spaceSessionId: string;
  themes?: RequestSpacesSpaceSessionThemeRequest[] | null;
  timezone?: string | null;
}

export interface RequestSpacesSpaceEventRequest {
  audience?: string | null;
  eventTypes?: string[] | null;
  /** @minLength 1 */
  languageCode: string;
  themes?: string[] | null;
}

export interface RequestSpacesSpaceSessionEventRequest {
  name?: string | null;
  slug?: string | null;
}

export interface RequestSpacesSpaceSessionExpertRequest {
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

export interface RequestSpacesSpaceSessionThemeRequest {
  name?: string | null;
  slug?: string | null;
}

export interface RequestTag {
  description?: string | null;
  tagName?: string | null;
  tagType?: string | null;
  translations?: string[] | null;
}

/** Model to catch the incoming request to set/filter by theme */
export interface RequestTheme {
  /** Should be false for setting a psychologist theme */
  isFocused: boolean;
  /** Key including the theme as a string */
  key?: string | null;
}

export interface RequestTwoFactorAuthenticationTwoFactorChangeStateRequest {
  code?: string | null;
  enable: boolean;
  method: ModelsTwoFactorAuthMethod;
}

export interface RequestTwoFactorAuthenticationTwoFactorCodeVerificationRequest {
  code?: string | null;
  method: ModelsTwoFactorAuthMethod;
}

export interface RequestUnconfirmedUnconfirmedFormAnswersRequest {
  answers?: Record<string, NewtonsoftJsonLinqJToken>;
  email?: string | null;
  formLanguage?: string | null;
  formModules?: string[] | null;
  unconfirmedDataId?: string | null;
}

export interface RequestUnconfirmedUnconfirmedQuestionListAnswersRequest {
  answers?: ModelsQuestionListAnswer[] | null;
  email?: string | null;
  languageCode?: string | null;
  questionListKey?: string | null;
  unconfirmedDataId?: string | null;
}

export interface RequestUnconfirmedUnconfirmedUserCurrentMood {
  currentMoods?: string[] | null;
  email?: string | null;
  unconfirmedDataId?: string | null;
}

export interface RequestUnconfirmedUnconfirmedUserPreferencesRequest {
  email?: string | null;
  preferences?: ModelsUserPreference[] | null;
  unconfirmedDataId?: string | null;
}

export interface RequestUpdateLanguageCodeRequest {
  languageCode?: string | null;
}

export interface RequestUpdatePhoneNumberRequest {
  /**
   * @format tel
   * @minLength 0
   * @maxLength 20
   */
  number: string;
}

export interface RequestUpdateSessionNotesRequest {
  answer?: string | null;
  question?: string | null;
}

export interface RequestUpdateUserRequest {
  acceptedMedicalDataProcessing: boolean;
  acceptedTermsAndConditions: boolean;
  /** @format uuid */
  employerId?: string | null;
  firstName?: string | null;
  hasDeskJob?: boolean | null;
  isManager?: boolean | null;
  isPartner?: boolean | null;
  isTranscriptionAllowed?: boolean | null;
  languageCode?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  signUpToNewsletter: boolean;
  /** @format int32 */
  yearOfBirth?: number | null;
}

export interface RequestUserConfirmationSignature {
  signature?: string | null;
}

export interface RequestUsersOtpLoginRequest {
  email?: string | null;
  password?: string | null;
}

export interface ResponseAcsAcsChatFile {
  fileName?: string | null;
  url?: string | null;
}

export interface ResponseAcsGetWhoElseInCallResponse {
  name?: string | null;
  userId?: string | null;
}

export interface ResponseAzureCommunicationServiceToken {
  communicationUserId?: string | null;
  endpointUrl?: string | null;
  /** @format date-time */
  expiresOn: string;
  firstName?: string | null;
  token?: string | null;
}

export interface ResponseClientSessionResponse {
  connectionLink?: string | null;
  consultOrSpace?: string | null;
  dossierNotes?: ModelsNotes[] | null;
  /** The psychologist ID for 1:1 consults */
  expertId?: string | null;
  expertImageUrl?: string | null;
  expertThumbnailUrl?: string | null;
  experts?: string[] | null;
  guestUrl?: string | null;
  languageCode?: string | null;
  /** @format date-time */
  notesAvailableAt?: string | null;
  sessionId?: string | null;
  shortDiscussedNotes?: string | null;
  /** @format date-time */
  startAt: string;
  status?: string | null;
  themeKey?: string | null;
  timezone?: string | null;
  title?: string | null;
  type?: string | null;
}

export interface ResponseClientSessionResponsePaginated {
  data: ResponseClientSessionResponse[];
  pagination: ResponsePagination;
}

export interface ResponseConsultResponse {
  clientEmail?: string | null;
  clientFirstName?: string | null;
  clientId?: string | null;
  clientTimezone?: string | null;
  clientUrl?: string | null;
  consultLanguage?: string | null;
  consultType?: string | null;
  dossierNotes?: ResponseDossierNotesResponse[] | null;
  employeeFullName?: string | null;
  employeeId?: string | null;
  /** @format int32 */
  id: number;
  noteAttachments?: ResponseConsultsNoteAttachmentFile[] | null;
  /** @format date-time */
  notesAvailableAt?: string | null;
  /** @format date-time */
  startedAt: string;
  status?: string | null;
  themeKey?: string | null;
}

export interface ResponseConsultsConsultFeedbackAnswerResponse {
  questionKey: string;
  questionType: string;
  value?: string | null;
}

export interface ResponseConsultsConsultFeedbackResponse {
  answers: ResponseConsultsConsultFeedbackAnswerResponse[];
  clientEmail: string;
  clientFirstName: string;
  clientId: string;
  clientLastName: string;
  /** @format int64 */
  consultId: number;
  consultType: string;
  /** @format date-time */
  startedAt: string;
}

export interface ResponseConsultsConsultFeedbackResponsePaginated {
  data: ResponseConsultsConsultFeedbackResponse[];
  pagination: ResponsePagination;
}

export interface ResponseConsultsConsultWithNotesResponse {
  canJoinVideoCall: boolean;
  chatThreadId?: string | null;
  clientTimezone?: string | null;
  consultLanguage?: string | null;
  consultStage?: string | null;
  consultType?: string | null;
  convertedToMarkDown: boolean;
  dossierNotes?: ResponseDossierNotesResponse[] | null;
  employee: ResponsePsychologistResponse;
  employeeFullName?: string | null;
  employerOfClientHasReferralToolkit: boolean;
  hasTranscription: boolean;
  /** @format int32 */
  id: number;
  notes?: string | null;
  roomId?: string | null;
  /** @format date-time */
  startedAt: string;
  status?: string | null;
  themeKey?: string | null;
  user: ResponseUsersUserWithNameAndEmployerIdResponse;
}

export interface ResponseConsultsConsultWithShortNotesResponse {
  consultType?: string | null;
  employeeFullName?: string | null;
  /** @format int32 */
  id: number;
  languageCode?: string | null;
  psychologistUrl?: string | null;
  shortDiscussedNotes?: string | null;
  /** @format date-time */
  startedAt: string;
  status?: string | null;
  themeKey?: string | null;
  userId?: string | null;
}

export interface ResponseConsultsNoteAttachmentFile {
  fileName?: string | null;
  url?: string | null;
}

export interface ResponseContentsArticleAudioFileResponse {
  playlistUrl?: string | null;
  timingUrl?: string | null;
  voiceName?: string | null;
}

export interface ResponseContentsArticleAuthorResponse {
  avatarUrl?: string | null;
  name?: string | null;
}

export interface ResponseContentsArticleContentResponse {
  contents?: ResponseContentsArticleContentResponse[] | null;
  cta?: string | null;
  isDownloadable: boolean;
  large?: string | null;
  medium?: string | null;
  src?: string | null;
  text?: string | null;
  textStyle?: string | null;
  thumbnail?: string | null;
  title?: string | null;
  type?: string | null;
  url?: string | null;
  variation?: string | null;
}

export interface ResponseContentsArticleResponse {
  audioFiles?: ResponseContentsArticleAudioFileResponse[] | null;
  authors?: ResponseContentsArticleAuthorResponse[] | null;
  contents?: ResponseContentsArticleContentResponse[] | null;
  /** @format int32 */
  durationInSeconds: number;
  /** @format int64 */
  id: number;
  /** @format date-time */
  modifiedAt?: string | null;
  reviewer?: string | null;
  themes?: string[] | null;
  thumbnailPath?: string | null;
  title?: string | null;
  url?: string | null;
}

export interface ResponseContentsContentAutocompleteResponses {
  autocompleteTerms?: string[] | null;
}

export interface ResponseContentsContentResponse {
  coverImage: ResponseCoverImageResponse;
  /** @format date-time */
  createdAt: string;
  /** @format int32 */
  durationInSeconds: number;
  /** @format int64 */
  id: number;
  /**
   * @deprecated
   * @format int32
   */
  readTime: number;
  themes?: string[] | null;
  thumbnailPath?: string | null;
  title?: string | null;
  type?: string | null;
  url?: string | null;
}

export interface ResponseContentsContentResponsePaginated {
  data: ResponseContentsContentResponse[];
  pagination: ResponsePagination;
}

export interface ResponseContentsCourseResponse {
  coverImage: ResponseCoverImageResponse;
  description?: string | null;
  /** @format int32 */
  duration: number;
  /** @format int64 */
  id: number;
  learningGoals?: string[] | null;
  lessons?: ResponseContentsLessonResponse[] | null;
  themes?: string[] | null;
  title?: string | null;
}

export interface ResponseContentsLessonResponse {
  coverImage: ResponseCoverImageResponse;
  /** @format int32 */
  duration: number;
  engagementStatus?: string | null;
  /** @format int64 */
  id: number;
  introduction: ResponseContentsLessonResponseLessonIntroduction;
  /** @format int32 */
  lessonNo: number;
  title?: string | null;
  type?: string | null;
}

export interface ResponseContentsLessonResponseLessonIntroduction {
  description?: string | null;
  heading?: string | null;
  image: ResponseCoverImageResponse;
}

export interface ResponseContentsManagerMixedContentResponse {
  contents?: ResponseContentsContentResponse[] | null;
}

export interface ResponseContentsMixedContentResponse {
  contentCustomizedForUser: boolean;
  contents?: ResponseContentsContentResponse[] | null;
}

export interface ResponseContentsUpdateContentEngagementResponse {
  /** @format int64 */
  contentId: number;
  contentType?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  modifiedAt?: string | null;
  status?: string | null;
}

export interface ResponseContentsVideoResponse {
  /** @format date-time */
  createdAt: string;
  /** @format int32 */
  durationInSeconds: number;
  /** @format int64 */
  id: number;
  themes?: string[] | null;
  thumbnailPath?: string | null;
  title?: string | null;
  url?: string | null;
}

export interface ResponseCoverImageResponse {
  large?: string | null;
  medium?: string | null;
  source?: string | null;
  thumbnail?: string | null;
}

export interface ResponseCreateUnconfirmedUserResponse {
  signature?: string | null;
  unconfirmedDataId?: string | null;
}

export interface ResponseDossierNotesResponse {
  answer?: string | null;
  /** @format int32 */
  consultId: number;
  question?: string | null;
}

export interface ResponseEmployerResponse {
  /** @format uuid */
  id: string;
  name?: string | null;
  planhatId?: string | null;
}

export interface ResponseEmployerResponsePaginated {
  data: ResponseEmployerResponse[];
  pagination: ResponsePagination;
}

export interface ResponseEmployersEmployerReferralToolkitFileResponse {
  fileName: string;
  languageCode: string;
}

export interface ResponseEmployersEmployerReferralToolkitResponse {
  description?: string | null;
  files: ResponseEmployersEmployerReferralToolkitFileResponse[];
}

export interface ResponseEmployersEmployerSsoResponse {
  /** @format uuid */
  employerId: string;
  provider?: string | null;
  ssoSupported: boolean;
}

export interface ResponseEmployersHrUserResponse {
  email?: string | null;
  firstName?: string | null;
  id?: string | null;
  lastName?: string | null;
  userId?: string | null;
}

export interface ResponseExpertsGetExpertDetailsResponse {
  isTranscriptionAllowed: boolean;
  userId?: string | null;
  worksTwentyFourSeven: boolean;
}

export interface ResponseFlagsResources {
  /** @format uri */
  flagsUrl?: string | null;
}

export interface ResponseFocusAreaResources {
  /** @format uri */
  iconUrl?: string | null;
}

export interface ResponseHostClientWithRelationshipResponse {
  calendar: ResponsePsychologistCalendarsResponse;
  email: string | null;
  /** @format uuid */
  employerId?: string | null;
  firstName?: string | null;
  id: string | null;
  isInRelationWithCurrentPsychologist: boolean;
  isLockedOut: boolean;
  isPartner: boolean;
  languageCode?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  preferences?: ResponseUserPreferenceResponse[] | null;
  roles?: ResponseOpenUpRole[] | null;
  tags?: ResponseTag[] | null;
  twoFactorEnabled: boolean;
  /** @format int32 */
  userNumber: number;
  /** @format int32 */
  yearOfBirth?: number | null;
}

export interface ResponseHumanResourcesEmployerResponse {
  /** @format uuid */
  id: string;
  name?: string | null;
  slug?: string | null;
}

export interface ResponseLastCompletedConsultByTypeResponse {
  expertFullName?: string | null;
  expertId?: string | null;
  expertIsAvailable?: boolean | null;
  expertProfileImageUrl?: string | null;
  expertProfileThumbnailUrl?: string | null;
  languageCode?: string | null;
  /** @format int32 */
  lastConsultId?: number | null;
  sessionType?: string | null;
}

export interface ResponseNotification {
  /** @format int32 */
  id: number;
  key?: string | null;
  /** @format date-time */
  validUntil: string;
}

/** @format int32 */
export enum ResponseOpenUpRole {
  Automation = "Automation",
  Guest = "Guest",
  Client = "Client",
  Psychologist = "Psychologist",
  Admin = "Admin",
  Manager = "Manager",
}

export interface ResponsePagination {
  /** @format int32 */
  currentPage: number;
  hasNextPage: boolean;
  /** @format int32 */
  limit: number;
  /** @format int32 */
  total: number;
}

export interface ResponsePsychologistCalendarsResponse {
  calendarId?: string | null;
  description?: string | null;
  summary?: string | null;
  timeZone?: string | null;
}

export interface ResponsePsychologistClientResponse {
  calendar: ResponsePsychologistCalendarsResponse;
  email: string | null;
  /** @format uuid */
  employerId?: string | null;
  firstName?: string | null;
  id: string | null;
  isLockedOut: boolean;
  isPartner: boolean;
  languageCode?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  preferences?: ResponseUserPreferenceResponse[] | null;
  roles?: ResponseOpenUpRole[] | null;
  tags?: ResponseTag[] | null;
  twoFactorEnabled: boolean;
  /** @format int32 */
  userNumber: number;
  /** @format int32 */
  yearOfBirth?: number | null;
}

export interface ResponsePsychologistClientResponsePaginated {
  data: ResponsePsychologistClientResponse[];
  pagination: ResponsePagination;
}

export interface ResponsePsychologistConsultInformationResponse {
  clientTimezone?: string | null;
  consultLanguage?: string | null;
  consultStage?: string | null;
  consultType?: string | null;
  employee: ResponsePsychologistResponse;
  employeeFullName?: string | null;
  guestUrl?: string | null;
  /** @format int32 */
  id: number;
  psychologistUrl?: string | null;
  /** @format date-time */
  startedAt: string;
  status?: string | null;
  themeKey?: string | null;
  user: ResponseUserResponse;
}

export interface ResponsePsychologistConsultInformationResponsePaginated {
  data: ResponsePsychologistConsultInformationResponse[];
  pagination: ResponsePagination;
}

export interface ResponsePsychologistConsultResponse {
  canJoinVideoCall: boolean;
  chatThreadId?: string | null;
  clientTimezone?: string | null;
  clientUrl?: string | null;
  consultLanguage?: string | null;
  consultStage?: string | null;
  consultType: string | null;
  dossierNotes?: ResponseDossierNotesResponse[] | null;
  employee: ResponsePsychologistResponse;
  employeeFullName?: string | null;
  /** @format int32 */
  id: number;
  notes?: string | null;
  psychologistUrl?: string | null;
  roomId?: string | null;
  /** @format date-time */
  startedAt: string;
  status?: string | null;
  themeKey?: string | null;
  user: ResponseUserResponse;
}

export interface ResponsePsychologistGetPsychologistConsultsResponse {
  canJoinVideoCall: boolean;
  chatThreadId?: string | null;
  clientTimezone?: string | null;
  clientUrl?: string | null;
  consultLanguage?: string | null;
  consultStage?: string | null;
  consultType?: string | null;
  dossierNotes?: ResponseDossierNotesResponse[] | null;
  employee: ResponsePsychologistResponse;
  employeeFullName?: string | null;
  employerOfClientHasReferralToolkit: boolean;
  guestUrl?: string | null;
  /** @format int32 */
  id: number;
  notes?: string | null;
  psychologistUrl?: string | null;
  roomId?: string | null;
  /** @format date-time */
  startedAt: string;
  status?: string | null;
  themeKey?: string | null;
  user: ResponseUserResponse;
}

export interface ResponsePsychologistGetPsychologistConsultsResponsePaginated {
  data: ResponsePsychologistGetPsychologistConsultsResponse[];
  pagination: ResponsePagination;
}

export interface ResponsePsychologistResponse {
  email?: string | null;
  firstName?: string | null;
  hasLinkedCalendar: boolean;
  id?: string | null;
  isActive: boolean;
  isLockedOut: boolean;
  languageCode?: string | null;
  lastName?: string | null;
  personalUrlHandle?: string | null;
  phoneNumber?: string | null;
  tags?: RequestTag[] | null;
  worksTwentyFourSeven: boolean;
}

export interface ResponsePsychologistResponsePaginated {
  data: ResponsePsychologistResponse[];
  pagination: ResponsePagination;
}

export interface ResponsePsychologistTwoFactorNotEnforcedExpertProfileResponse {
  description?: string | null;
  email?: string | null;
  firstName?: string | null;
  hasLinkedCalendar: boolean;
  id?: string | null;
  imagePath?: string | null;
  isActive: boolean;
  isTranscriptionAllowed: boolean;
  languageCode?: string | null;
  lastName?: string | null;
  personalUrlHandle?: string | null;
  quote?: string | null;
  specialisation?: string | null;
  supportedLanguages?: string[] | null;
  tags?: RequestTag[] | null;
  thumbnailPath?: string | null;
  topics?: string[] | null;
  /** @format int32 */
  userNumber: number;
  worksTwentyFourSeven: boolean;
}

export interface ResponsePsychologistTwoFactorNotEnforcedExpertProfileResponsePaginated {
  data: ResponsePsychologistTwoFactorNotEnforcedExpertProfileResponse[];
  pagination: ResponsePagination;
}

export interface ResponsePsychologistTwoFactorNotEnforcedPsychologistResponse {
  email?: string | null;
  firstName?: string | null;
  hasLinkedCalendar: boolean;
  id?: string | null;
  isActive: boolean;
  isTranscriptionAllowed: boolean;
  languageCode?: string | null;
  lastName?: string | null;
  personalUrlHandle?: string | null;
  tags?: RequestTag[] | null;
  /** @format int32 */
  userNumber: number;
  worksTwentyFourSeven: boolean;
}

export interface ResponseQuestionListScoreResponse {
  category: ModelsEnumCategory;
  categoryTitle?: string | null;
  /** @format date-time */
  createdAt: string;
  key?: string | null;
  /** @format double */
  score: number;
  scoreDescription?: string | null;
  scoreIconInUnicode?: string | null;
  scoreTitle?: string | null;
  /** @format uuid */
  userId: string;
}

export interface ResponseQuestionListScoreResponsePaginated {
  data: ResponseQuestionListScoreResponse[];
  pagination: ResponsePagination;
}

export interface ResponseReportingCompanyOverTimeDataResponse {
  /** @format int64 */
  count: number;
  /** @format int32 */
  month: number;
  /** @format int32 */
  year: number;
}

export interface ResponseReportingCompanyOverTimeGroupedDataResponse {
  /** @format int64 */
  count: number;
  /** @format int32 */
  month: number;
  type?: string | null;
  /** @format int32 */
  year: number;
}

export interface ResponseReportingGetGroupedOverTimeReportDataResponse {
  monthlyActivityRecords?:
    | ResponseReportingCompanyOverTimeGroupedDataResponse[]
    | null;
  /** @format int64 */
  total: number;
}

export interface ResponseReportingGetOverTimeReportDataResponse {
  monthlyActivityRecords?:
    | ResponseReportingCompanyOverTimeDataResponse[]
    | null;
  /** @format int64 */
  total: number;
}

export interface ResponseReportingGetSessionsTopicsDataResponse {
  employerId?: string | null;
  /** @format int64 */
  sessionsCount?: number | null;
  themeKey?: string | null;
  topicName?: string | null;
}

export interface ResponseResourcesUrls {
  flags: ResponseFlagsResources;
  focusArea: ResponseFocusAreaResources;
  sessionType: ResponseSessionTypeResources;
  theme: ResponseThemeResources;
}

export interface ResponseSendBirdSessionToken {
  /** @format int64 */
  expiresAt: number;
  token?: string | null;
}

export interface ResponseSessionTypeResources {
  /** @format uri */
  bookingImagesUrl?: string | null;
  /** @format uri */
  iconUrl?: string | null;
}

export interface ResponseSpacesGetClientSpaceResponse {
  /** @format date-time */
  date: string;
  experts?: string[] | null;
  languageCode?: string | null;
  /** @format uuid */
  spaceId: string;
  status?: string | null;
  timezone?: string | null;
  title?: string | null;
  type?: string | null;
}

export interface ResponseSpacesGetClientSpaceResponsePaginated {
  data: ResponseSpacesGetClientSpaceResponse[];
  pagination: ResponsePagination;
}

export interface ResponseSpacesSpaceResponse {
  /** @format date-time */
  dateTime: string;
  isFull: boolean;
  isUserRegistered: boolean;
  language?: string | null;
  theme?: string | null;
  title?: string | null;
  type?: string | null;
}

export interface ResponseSpacesSpaceUserResponse {
  /** @format date-time */
  dateTime: string;
  errorMessage?: string | null;
  spaceConnectionLink?: string | null;
  spaceExperts?: string | null;
  spaceLanguage?: string | null;
  spaceTheme?: string | null;
  spaceTitle?: string | null;
  spaceType?: string | null;
  spotsAvailable: boolean;
  status?: string | null;
  timezone?: string | null;
  userEmail?: string | null;
  userName?: string | null;
}

export interface ResponseTag {
  description?: string | null;
  name?: string | null;
  tagType: ResponseTagType;
  translations?: string[] | null;
}

export interface ResponseTagType {
  isExclusive: boolean;
  name?: string | null;
}

export interface ResponseTagsExpertTag {
  description?: string | null;
  tagName?: string | null;
  tagType?: string | null;
}

export interface ResponseThemeResources {
  /** @format uri */
  iconUrl?: string | null;
  /** @format uri */
  onboardingImagesUrl?: string | null;
  /** @format uri */
  themePageImageUrl?: string | null;
}

export interface ResponseThemeResponse {
  isFocused: boolean;
  key?: string | null;
  /** @format int32 */
  ordinal?: number | null;
  tags?: ResponseTag[] | null;
  /** @format uuid */
  themeDefinitionId: string;
}

export interface ResponseTwoFactorCodeResponse {
  isEligibleToRequestNewCode: boolean;
  message?: string | null;
  phoneNumber?: string | null;
  /** @format int32 */
  timeout: number;
}

export interface ResponseTwoFactorNotEnforcedAvatarResponse {
  large?: string | null;
  medium?: string | null;
  src?: string | null;
  thumbnail?: string | null;
}

export interface ResponseTwoFactorNotEnforcedBookNonConfirmedConsultResponse {
  calendarEventId?: string | null;
  /** @format date-time */
  createdAt: string;
  employeeId?: string | null;
  /** @format uuid */
  id: string;
  isConfirmationReminderEmailSent: boolean;
  sessionToken?: string | null;
  /** @format date-time */
  startedAt: string;
  tags?: ResponseTwoFactorNotEnforcedTag[] | null;
  userEmail?: string | null;
}

export interface ResponseTwoFactorNotEnforcedConsultResponse {
  canJoinVideoCall: boolean;
  chatThreadId?: string | null;
  clientEmail?: string | null;
  clientFirstName?: string | null;
  clientId?: string | null;
  clientTimezone?: string | null;
  clientUrl?: string | null;
  consultLanguage?: string | null;
  consultType?: string | null;
  employeeFullName?: string | null;
  employeeId?: string | null;
  employeeImageUrl?: string | null;
  /** @format int32 */
  employeeNumber: number;
  employeePersonalUrlHandle?: string | null;
  employeeThumbnailUrl?: string | null;
  /** @format int32 */
  id: number;
  roomId?: string | null;
  /** @format date-time */
  startedAt: string;
  status?: string | null;
  themeKey?: string | null;
}

export interface ResponseTwoFactorNotEnforcedDescriptionResponse {
  content?: ResponseTwoFactorNotEnforcedUnorderedListContentResponse[] | null;
  text?: string | null;
  textStyle?: string | null;
  type?: string | null;
}

export interface ResponseTwoFactorNotEnforcedEventTypeResponse {
  name?: string | null;
  slug?: string | null;
}

export interface ResponseTwoFactorNotEnforcedGetSpaceEventResponse {
  description?: ResponseTwoFactorNotEnforcedDescriptionResponse[] | null;
  /** @format int32 */
  duration: number;
  eventType: ResponseTwoFactorNotEnforcedEventTypeResponse;
  id?: string | null;
  language?: string | null;
  sessions?: ResponseTwoFactorNotEnforcedSpaceSessionResponse[] | null;
  themes?: ResponseTwoFactorNotEnforcedSpaceEventThemeResponse[] | null;
  title?: string | null;
  translations?: ResponseTwoFactorNotEnforcedTranslationResponse[] | null;
}

export interface ResponseTwoFactorNotEnforcedGetSpaceEventResponsePaginated {
  data: ResponseTwoFactorNotEnforcedGetSpaceEventResponse[];
  pagination: ResponsePagination;
}

export interface ResponseTwoFactorNotEnforcedSpaceEventThemeResponse {
  name?: string | null;
}

export interface ResponseTwoFactorNotEnforcedSpaceSessionResponse {
  /** @format date-time */
  endedAt: string;
  id?: string | null;
  speakers?: ResponseTwoFactorNotEnforcedSpeakerResponse[] | null;
  /** @format date-time */
  startedAt: string;
  timezone?: string | null;
}

export interface ResponseTwoFactorNotEnforcedSpeakerResponse {
  avatar: ResponseTwoFactorNotEnforcedAvatarResponse;
  firstName?: string | null;
  lastName?: string | null;
}

export interface ResponseTwoFactorNotEnforcedTag {
  description?: string | null;
  name?: string | null;
  tagType: ResponseTagType;
  translations?: string[] | null;
}

export interface ResponseTwoFactorNotEnforcedTranslationResponse {
  eventId?: string | null;
  language?: string | null;
}

export interface ResponseTwoFactorNotEnforcedUnorderedListContentResponse {
  text?: string | null;
  textStyle?: string | null;
  type?: string | null;
}

export interface ResponseTwoFactorNotEnforcedUserResponse {
  email?: string | null;
  /**
   * Boolean indicating whether the user has a valid phone number associated with their account
   * Calculated at runtime.
   */
  hasValidPhoneNumber: boolean;
  /** Boolean indicating whether details of the user have been saved */
  isRegistered: boolean;
  languageCode?: string | null;
  /** List of external 2FA token providers set up by user */
  userTokenProviders?: string[] | null;
}

export interface ResponseUserPreferenceResponse {
  category?: string | null;
  name?: string | null;
  value: boolean;
}

export interface ResponseUserResponse {
  /** @format date-time */
  createdAt: string;
  email?: string | null;
  /** @format uuid */
  employerId?: string | null;
  employerName?: string | null;
  firstName?: string | null;
  /**
   * Boolean indicating whether the user has a valid phone number associated with their account
   * Calculated at runtime.
   */
  hasValidPhoneNumber: boolean;
  id?: string | null;
  isEmailConfirmed: boolean;
  isFocusThemeSet: boolean;
  isGuestLogin: boolean;
  isManager: boolean;
  isPartner: boolean;
  isRegistered: boolean;
  isRegisteredWithPassword: boolean;
  isTranscriptionAllowed: boolean;
  languageCode?: string | null;
  lastName?: string | null;
  loginProvider?: string | null;
  phoneNumber?: string | null;
  phoneNumberConfirmed: boolean;
  preferences?: ResponseUserPreferenceResponse[] | null;
  roles?: ResponseOpenUpRole[] | null;
  signUpToNewsletter: boolean;
  twoFactorEnabled: boolean;
  /** List of external 2FA token providers set up by user */
  userTokenProviders?: string[] | null;
  /** @format int32 */
  yearOfBirth?: number | null;
}

export interface ResponseUserResponsePaginated {
  data: ResponseUserResponse[];
  pagination: ResponsePagination;
}

export interface ResponseUsersUserWithNameAndEmployerIdResponse {
  /** @format uuid */
  employerId?: string | null;
  firstName?: string | null;
  id?: string | null;
  lastName?: string | null;
}

export interface ResponseVitalityCheckinLastVitalityCheckinDateResponse {
  /** @format date-time */
  lastLegacyCheckinDate?: string | null;
  /** @format date-time */
  lastVitalityCheckinDate?: string | null;
}

export interface ResponseVitalityCheckinVitalityCheckinAnswerResponse {
  /** @format int32 */
  intValue?: number | null;
  textValue?: string | null;
}

export interface ResponseVitalityCheckinVitalityCheckinModuleResponse {
  moduleName?: string | null;
  /** @format int32 */
  order: number;
  themeKey?: string | null;
}

export interface ResponseVitalityCheckinVitalityCheckinModuleScoreResponse {
  category?: string | null;
  /** @format date-time */
  createdAt: string;
  isFocusedTheme: boolean;
  key?: string | null;
  /** @format double */
  progressPercent?: number | null;
  questionsWithAnswers?:
    | ResponseVitalityCheckinVitalityCheckinQuestionsWithAnswersResponse[]
    | null;
  /** @format double */
  score: number;
  scoreDescription?: string | null;
  scoreTitle?: string | null;
  themeKey?: string | null;
}

export interface ResponseVitalityCheckinVitalityCheckinOverallScoreResponse {
  /** @format date-time */
  checkinDateTime?: string | null;
  isFollowUpCheckinComplete: boolean;
  moduleScores?:
    | ResponseVitalityCheckinVitalityCheckinModuleScoreResponse[]
    | null;
  /** @format date-time */
  nextCheckinDateTime?: string | null;
  overallScoreCategory?: string | null;
}

export interface ResponseVitalityCheckinVitalityCheckinQuestionsWithAnswersResponse {
  answers?: ResponseVitalityCheckinVitalityCheckinAnswerResponse[] | null;
  isScored: boolean;
  questionKey?: string | null;
  questionText?: string | null;
  questionType?: string | null;
  /** @format double */
  score?: number | null;
}

export interface ResponseVitalityCheckinVitalityCheckinScoreOverTimeResponse {
  overallScoreOverTime?:
    | ResponseVitalityCheckinVitalityCheckinScoreResponse[]
    | null;
  themeListScoreOverTime?:
    | ResponseVitalityCheckinVitalityCheckinThemeScoreOverTimeResponse[]
    | null;
}

export interface ResponseVitalityCheckinVitalityCheckinScoreResponse {
  /** @format date */
  checkinDate: string;
  /** @format double */
  score: number;
}

export interface ResponseVitalityCheckinVitalityCheckinThemeScoreOverTimeResponse {
  scoresOverTime?: ResponseVitalityCheckinVitalityCheckinScoreResponse[] | null;
  themeKey?: string | null;
}

export type SaveVitalityCheckinAnswersPayload = ModelsQuestionListAnswers[];

export interface SearchParams {
  channel_url?: string;
  user_id?: string;
}

export interface SearchParams2 {
  audience?: string;
  languageCode: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  page?: number;
  search?: string;
  searchTerm: string;
  types?: string[];
}

export interface SendEmailVerificationParams {
  /** The email address to which this verification link will be sent */
  email?: string;
  /** The Uri where user should be redirected after verification of the email address */
  redirectUri?: string;
}

export interface ServicesSendBirdModelsSendBirdUser {
  access_token?: string | null;
  /** @format int64 */
  created_at: number;
  discovery_keys?: string[] | null;
  has_ever_logged_in: boolean;
  is_active: boolean;
  is_online: boolean;
  /** @format int64 */
  last_seen_at: number;
  metadata?: Record<string, string | null>;
  nickname?: string | null;
  preferred_languages?: string[] | null;
  profile_url?: string | null;
  /** @format int32 */
  unread_message_count: number;
  user_id?: string | null;
}

export type SetConsultTagsPayload = string[];

export type SetFocusedThemesPayload = string[];

export type SetPsychologistThemesPayload = string[];

export type SetUserCurrentMoodsPayload = string[];

export type SetUserPreferencesBody = ModelsUserPreference[];

export type SetUserTagsPayload = string[];

export interface TestModelsTestCalendar {
  calendarId?: string | null;
  refreshToken?: string | null;
}

export interface TestModelsTestConsult {
  session24AccessKey?: string | null;
  session24Id?: string | null;
  clientTimezone?: string | null;
  consultLanguage?: string | null;
  consultStage?: string | null;
  consultType?: string | null;
  employeeEmail?: string | null;
  meetingProvider: ModelsConsultMeetingProvider;
  notes?: string | null;
  /** @format int32 */
  notesAvailableAt?: number | null;
  /** @format int32 */
  startedAt: number;
  startedAtOffsetByMinutes: boolean;
  status?: string | null;
  themeKey?: string | null;
}

export interface TestModelsTestExternalQuestionnaire {
  /** @format int32 */
  createdAt: number;
  /** @format uuid */
  externalId: string;
  type?: string | null;
}

export interface TestModelsTestSpace {
  /** @format date-time */
  attendanceDate: string;
  /** @format int32 */
  attendanceRate?: number | null;
  /** @format int32 */
  capacity: number;
  /** @format int64 */
  date: number;
  experts?: TestModelsTestSpaceExpert[] | null;
  externalSpaceId?: string | null;
  externalSpaceTypeId?: string | null;
  spaceUserStatus?: string | null;
  theme?: string | null;
  timeZone?: string | null;
  title?: string | null;
}

export interface TestModelsTestSpaceExpert {
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

export interface TestModelsTestTag {
  type?: string | null;
  values?: string[] | null;
}

export interface TestModelsTestUser {
  calendar: TestModelsTestCalendar;
  completeQuestionLists: boolean;
  consults?: TestModelsTestConsult[] | null;
  createByPsychologist: boolean;
  createdBy?: string | null;
  email?: string | null;
  /** @format uuid */
  employerId?: string | null;
  externalQuestionnaires?: TestModelsTestExternalQuestionnaire[] | null;
  firstName?: string | null;
  isLockedOut: boolean;
  languageCode?: string | null;
  lastName?: string | null;
  password?: string | null;
  phoneNumber?: string | null;
  roles?: string[] | null;
  sendBirdUserId?: string | null;
  spaces?: TestModelsTestSpace[] | null;
  tags?: TestModelsTestTag[] | null;
  /** @format int32 */
  userNumber: number;
  /** @format int32 */
  yearOfBirth: number;
}

export interface UpdateInvitationLinkStatusParams {
  channelId: string;
  isEnabled?: boolean;
}

export interface UpdateUserLanguageParams {
  logout?: boolean;
}

export interface UpdateUserPhoneNumberWithTokenParams {
  token?: string;
}

export interface UploadChatAttachmentPayload {
  /** @format binary */
  file?: File;
}

export interface UploadSessionNoteAttachmentPayload {
  /** @format binary */
  file?: File;
}
